import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { PresentationCommentTemplate } from './variants/PresentationComment'
import { PresentationSlideTemplate } from './variants/PresentationSlide'

const commentVariant = {
  ...productRowVariantForPath('presentation', 2),
  Template: PresentationCommentTemplate,
} as const satisfies RowVariantDefinition

const slideVariant = {
  ...productRowVariantForPath('presentation', 3),
  Template: PresentationSlideTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('presentation')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [commentVariant, slideVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [commentVariant, slideVariant],
    fallback: productRows.submsges.fallback,
  },
})
